<template>
  <el-row>
    <el-col :span="spanTitle">
      <div class="input-title">
        <required-tag v-if="required"></required-tag>
        ブランド
      </div>
    </el-col>
    <el-col :span="spanSetting">
      <brand-input-core
        :brandid.sync="brandidComputed"
        :brandname.sync="brandnameComputed"
      >
      </brand-input-core>
    </el-col>
  </el-row>
</template>

<script>
import RequiredTag from '@/components/RequiredTag.vue'
import BrandInputCore from '@/components/BrandInputCore'
import Constants from './Constants'

export default {
  name: 'BrandSelector',
  components: {
    requiredTag: RequiredTag,
    BrandInputCore: BrandInputCore
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    brandid: {
      type: Number
    },
    brandname: {
      type: String
    },
    spanTitle: {
      type: Number,
      default: Constants.SPAN_TITLE
    },
    spanSetting: {
      type: Number,
      default: Constants.SPAN_INPUT
    },
    required: {
      type: Boolean,
      default: false
    },
    category1st: {
      type: Number,
      default: 0
    }
  },
  computed: {
    brandidComputed: {
      get () {
        return this.brandid
      },
      set (value) {
        this.$emit('update:brandid', value)
      }
    },
    brandnameComputed: {
      get () {
        return this.brandname
      },
      set (value) {
        this.$emit('update:brandname', value)
      }
    }
  }
}
</script>

<style scoped>
div.input-title {
  text-align: end;
  vertical-align: middle;
  margin-top: 10px;
  margin-right: 10px;
}
.el-select {
  width: 100%;
}
</style>
